var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tw-w-full tw-h-full"},[(_vm.userRole === 'admin')?_c('AdminDashboard'):_vm._e(),(_vm.userRole === 'host')?_c('HostDashboard'):_vm._e(),(_vm.userRole === 'observer')?_c('ObserverDashboard'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }